import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Preloader from '../components/Preloader';
import { API_ENDPOINTS } from '../config/api';

import axios from 'axios';
const url = API_ENDPOINTS.EMERGENCY_NUMBERS;

const EmergencyNumbers = (props) => {
  const { cached, updateCache, updateCountriesHandler } = props;
  const [tableMessage, setTableMessage] = useState('Loading data...');
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [countries, setCountries] = useState([]);
  const [emergencyNumbers, setEmergencyNumbers] = useState(null);
  const [updated, setUpdated] = useState({
    emergencyNumbers: false,
    countries: false,
  });

  useEffect(() => {
    if ( cached.countries ) {
      setCountries(cached.countries.sort((a, b) => (a.name > b.name) ? 1 : -1));
    } else if (!updated.countries) {
      setUpdated({...updated, countries: true});
      updateCountriesHandler();
    }

    if ( cached.emergencyNumbers ) {
      setEmergencyNumbers(cached.emergencyNumbers.sort((a, b) => (a.countrycode > b.countrycode) ? 1 : -1));
    } else if (!updated.emergencyNumbers) {
      setUpdated({...updated, emergencyNumbers: true});
      makeRequest('GET');
    }
  }, [JSON.stringify(cached?.countries), JSON.stringify(cached?.emergencyNumbers)]);

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  }

  const onSubmitHandler = () => {
    if ( formData.id >= 0 ) {
      makeRequest('PUT');
    } else {
      makeRequest('POST');
    }
  }

  const clearFormHandler = () => {
    setFormData({});
  }

  const onDeleteHandler = (id) => {
    if (window.confirm('Do you really want to delete it?')) {
      makeRequest('DELETE', id);
    }
  }

  const makeRequest = (method, id) => {
    setDisabled(true);

    let requestUrl = url;
    let message = method === 'POST' ? 'Item is added' : 
                  method === 'PUT' ? 'Item is updated' :
                  method === 'DELETE' ? 'Item is deleted' : null;

    const requestData = {
      method: method,
      signal: AbortSignal.timeout(20000)
    };

    if ( method === 'POST' || method === 'PUT' ) {
      requestData.data = { ...formData };
    }

    if ( method === 'DELETE' || method === 'PUT' ) {
      const requestId = id ? id : formData.id;

      requestUrl += `/${requestId}`;
    }

    axios(requestUrl, requestData).then((response) => {
      clearFormHandler();

      if ( method === 'GET' ) {
        updateCache(response.data);
        setDisabled(false);
      } else {
        makeRequest('GET');
      }

      if ( message ) {
        toast.success(message, {
          position: 'top-right'
        });
      }
    }).catch( (error) => {
      let err = 'Error: ';

      if (error.response) {
        err += error.response.data.errors;
      } else if (error.request) {
        err += 'No response!';
      } else {
        err += error.message;
      }

      setTableMessage(err);

      toast.error(err, {
        position: 'top-right'
      });
      
      setDisabled(false);
    });
  }

  const updating = typeof countries === 'undefined' || typeof emergencyNumbers === 'undefined' ? true : false;

  return (
      <div style={{minHeight: 200}} className="container-fluid position-relative">
        { updating ? <Preloader /> : (
          <React.Fragment>
            <h2 className="mt-5">Emergency Numbers</h2>

            <div className="mt-5">
              <div className="form-group row">
                <div className="col-3 form-group">
                  <label className="form-label">Country Code</label>
                  <select
                    value={formData.countrycode || ''}
                    name="countrycode"
                    onChange={(e) => onChangeHandler(e) } 
                    disabled={disabled || updating}
                    className="form-select"
                  >
                    <option value=''>-</option>
                    { 
                      countries ? countries.map(c => {
                        return <option key={`country-option-${c.id}`} value={c.countrycode}>{`(${c.countrycode}) ${c.name}`}</option>;
                      }) : null 
                    }
                </select>
                </div>
                <div className="col-3 form-group">
                  <label className="form-label">Ambulance</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Ambulance"
                    name="ambulance"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.ambulance || ''}
                  />
                </div>
                <div className="col-3 form-group">
                  <label className="form-label">Police</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Police"
                    name="police"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.police || ''}
                  />
                </div>
                <div className="col-3 form-group">
                  <label className="form-label">Fire</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Fire"
                    name="fire"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.fire || ''}
                  />
                </div>
              </div>

              <button disabled={disabled || updating} className="btn btn-primary me-2" onClick={() => onSubmitHandler()}>{formData.id >= 0 ? 'Update' : 'Add'}</button>
              <button disabled={disabled || updating} className="btn btn-secondary" onClick={() => clearFormHandler()}>Clear</button>
          </div>            

            <table className="table table-hover mt-5">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style={{width: '100%'}}>Country Code</th>
                  <th scope="col">Ambulance</th>
                  <th scope="col">Police</th>
                  <th scope="col">Fire</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                { emergencyNumbers ? emergencyNumbers.map((item, index) => {
                  const countryIndex = countries.find(c => c.countrycode === item.countrycode);
                  const countryName = countryIndex && countryIndex.name ? <i>({countryIndex.name})</i> : null;
                  return (
                    <tr key={`emergency-row-${index}`}>
                      <th scope="row">{index+1}</th>
                      <td>{item.countrycode && item.countrycode !== '' && item.countrycode !== ' ' ? <div><b>{item.countrycode}</b> {countryName}</div> : '-'}</td>
                      <td>{item.ambulance ? item.ambulance : '-'}</td>
                      <td>{item.police ? item.police : '-'}</td>
                      <td>{item.fire ? item.fire : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>
                        <button className="btn btn-danger me-1" onClick={() => onDeleteHandler(item.id)}>Delete</button>
                        <button className="btn btn-primary ms-1" onClick={() => {
                          setFormData({ ...item });
                          window.scrollTo(0, 0);
                        }}>Edit</button>
                      </td>
                  </tr>
                  );
                }) : <tr><td style={{textAlign: 'center', padding: 32}} colSpan="6">{tableMessage}</td></tr> }
              </tbody>
            </table>
          </React.Fragment>
        )}
      </div>
  );
}

export default EmergencyNumbers;
